module.exports = __webpack_public_path__ + "img/bangyangrenwu@3x.4e45e421.png";